<template>
  <div class="hello">
    <h2>Wireless Card</h2>
    <h2>User Manual For IOS </h2>
    <img :src="currentLogo" alt="Wireless Tag Logo" class="logo" />
    
       <!-- 新增的三个竖排按钮 -->
    <div class="button-container">
        <router-link to="/card/dual/ios/en">
         

      <van-button  type="primary" block> <span class="fi fi-gb"> </span>  English</van-button>
      </router-link>
       <router-link to="/card/dual/ios/nl">
        <van-button  type="primary" block> <span class="fi fi-nl"> </span> Nederlands</van-button>
       </router-link>
    <router-link to="/card/dual/ios/fr">
      <van-button  type="primary" block> <span class="fi fi-fr"/> Français</van-button>
    </router-link>

      
      <router-link to="/card/dual/ios/de">
      <van-button  type="primary" block> <span class="fi fi-de"/> Deutsch</van-button>
    </router-link>
     
    </div>
        <img src="../../assets/logo_ios.png" alt="Wireless Tag Logo" class="android" />

  </div>
</template>


<script>
import { Button } from 'vant';
import "flag-icons/css/flag-icons.min.css";
export default {
  name: 'IosManualCard',
  props: {
    msg: String
  },
  components: {
    [Button.name]: Button,
  },computed: {
    currentLogo() {
      return require('../../assets/crd.jpg');
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.button-container {
  display: flex;
  flex-direction: column;
  gap: 20px; /* 按钮之间的垂直间距 */
  margin: 30px; /* 设置左边距 */

}
.hello { 
  border-radius: 16px; /* 圆角 */
  margin: 20px; /* 可选：外边距 */
  overflow: hidden; /* 防止子元素超出圆角边界 */
  width: 90%;
  height: 90%;
}
.logo {
  width: 100px; /* 或根据需要调整 */
  height: auto;
  margin-bottom: 10px;
  border-radius: 8px;
}
.android {
  width: 200px; /* 或根据需要调整 */
  height: auto;
  margin-bottom: 10px;
  border-radius: 8px;
}
</style>
